import React, { useContext } from "react";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Icon } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { Clock } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import { useTimer } from "../../../customHooks";

export const ChatHeaderTimer = () => {
  const { liveSession } = useContext(LiveSessionContext);
  const { time } = useTimer({ initialTime: liveSession?.startedAt });

  return (
    <Flex justifyContent="space-between" alignItems="center" marginRight={4}>
      <Icon>
        <Clock />
      </Icon>
      <Text size="micro" style={{ minWidth: "60px" }}>
        {" "}
        {time}
      </Text>
    </Flex>
  );
};

export default ChatHeaderTimer;
